import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AccessRole, LocalService } from 'lib-base';

export function hasPermisoGuard(requiredPermiso: AccessRole | AccessRole[]): CanActivateFn {
  return (route, state) => {
    const localService = inject(LocalService);
    if (Array.isArray(requiredPermiso)) {
      return requiredPermiso.some((permiso) => localService.hasRole(permiso));
    }
    return localService.hasRole(requiredPermiso);
  };
}
